import { AuthenticatedHttpClient } from '@brunommsilva/react-foundations';

import appConfig from '../../config/app-config';
import authService from '../../lib/auth/auth-service';
import tokenStorage from '../../lib/auth/token-storage';

// Initialize the AuthenticatedHttpClient with host app auth handlers
AuthenticatedHttpClient.initialize(tokenStorage, {
  isTokenExpired: (token) => authService.isTokenExpired(token),
  refreshToken: async () => {
    await authService.refreshToken();
  },
  onLogout: () => authService.onLogout(),
});

export default abstract class AccountingApiClient<
  E,
  L = E[],
> extends AuthenticatedHttpClient<E, L> {
  constructor(
    basePath: string = '',
    timeoutMs: number = appConfig.getApiRequestTimeout()
  ) {
    super(`${appConfig.getApiBaseURL()}${basePath}`, { timeoutMs });
  }
}
